import { Injectable, EventEmitter } from '@angular/core';

import { contentHeaders, config } from '../config';

@Injectable()
export class NotificationService {
  public notificationEmitter = new EventEmitter();

  public updateNotification() {
    this.notificationEmitter.emit('update');
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/common/services/notification.service.ts